import * as React from 'react';

import './spinner.module.scss';
import spinnerSvg from './images/spinner.svg';

export class Spinner extends React.PureComponent {
  render() {
    return (
      <div className="spinner">
        <img src={spinnerSvg} />
      </div>
    );
  }
}
